import React from "react";
import { Box, Loading, PressableOpacity } from "app/components/common";
import { StyleSheet } from "react-native";
import FastImage from "react-native-fast-image";
import { widthPercentageToDP } from "react-native-responsive-screen";
import ClearIcon from "../../Icons/ClearIcon";
import theme from "app/Theme/Theme";
import CameraIcon from "app/components/Icons/CameraIcon";
import { isWebDesktop } from "@microdoing/shared/utils/deviceDetectors";

const PICTURE_SIZE = isWebDesktop ? 117 : widthPercentageToDP("45%");
const CLEAR_ICON_SIZE = isWebDesktop ? 25 : widthPercentageToDP("7%");

const styles = StyleSheet.create({
  pictureView: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "row",
  },
  pictureFrame: {
    zIndex: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    height: PICTURE_SIZE,
    width: PICTURE_SIZE,
    backgroundColor: theme.colors["neutral.200"],
    borderRadius: 100,
  },
  clearIcon: {
    position: "absolute",
    top: isWebDesktop ? 0 : CLEAR_ICON_SIZE,
    left: PICTURE_SIZE - CLEAR_ICON_SIZE,
    zIndex: 100,
    alignSelf: "flex-start",
    backgroundColor: "#3A3D5B",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    height: CLEAR_ICON_SIZE,
    width: CLEAR_ICON_SIZE,
    borderRadius: CLEAR_ICON_SIZE / 2,
  },
});

const PictureComponent = ({
  picture,
  loading,
  selectPhotoTapped,
  onClearPicture = () => {},
}) => {
  return (
    <Box flexDirection="row" alignItems="center" justifyContent="center">
      <PressableOpacity onPress={selectPhotoTapped} style={styles.pictureView}>
        {!!picture && !loading && (
          <FastImage
            source={{ uri: picture }}
            style={[styles.pictureFrame]}
            resizeMode="cover"
          />
        )}
        {!!loading && (
          <Box
            justifyContent="center"
            alignItems="center"
            backgroundColor="neutral.100"
            width={PICTURE_SIZE}
            height={PICTURE_SIZE}
            borderRadius={100}
          >
            <Loading size={30} />
          </Box>
        )}
        {!!picture && !loading && (
          <PressableOpacity onPress={onClearPicture} style={styles.clearIcon}>
            <ClearIcon />
          </PressableOpacity>
        )}
        {!picture && !loading && (
          <Box style={styles.pictureFrame}>
            {!loading && (
              <CameraIcon
                width={40}
                height={40}
                color={theme.colors["neutral.400"]}
              />
            )}
          </Box>
        )}
      </PressableOpacity>
    </Box>
  );
};

export default PictureComponent;
